export enum ServiceMessageMethod {
	SMS
}